export default __webpack_public_path__ + "static/media/gold-design-title.9fbd1561.svg";